import React from 'react'
import {
  formatMeetingDate,
  formatMeetingTimeRange,
  getMeetingTimezoneAbbreviation,
  formatCompleteMeetingDateTime,
  type MeetingDateRange,
} from '@chilipiper/booking-flow'

type Props = {
  date: MeetingDateRange
  timezone: string
}

export const DisplayDate = ({ date, timezone }: Props) => {
  return (
    <>
      {formatMeetingDate(date, timezone)}
      <br />
      {formatMeetingTimeRange(date, timezone)} {getMeetingTimezoneAbbreviation(date, timezone)}
    </>
  )
}

export const formatDate = (date: MeetingDateRange, timezone: string) => {
  return formatCompleteMeetingDateTime(date, timezone)
}
